import { createLogger } from '~~/shared/utils/logger'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const logger = createLogger({
    level: config.public.logLevel,
    tag: 'gremiumhub',
    fancy: import.meta.env.MODE !== 'production'
  })

  return {
    provide: {
      logger
    }
  }
})
